// extracted by mini-css-extract-plugin
module.exports = {"app-body-container":"AppBody_app-body-container__teWq9","app-title":"AppBody_app-title__1WASW","app-button-container":"AppBody_app-button-container__2D6QC"};